export default __webpack_public_path__ + "static/media/other.b84ffeed.svg";